import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import TuneIcon from '@mui/icons-material/Tune'
import {
    Box,
    Button,
    Divider,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Popover,
    SvgIcon,
    Typography
} from '@mui/material'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import toast from 'react-hot-toast'
import { Link as RouterLink } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'
import { settingsItems } from '@/navConfig'
import { hasRole } from '@/utils/hasRole'

export const AccountPopover = (props) => {
    const { anchorEl, onClose, open, onDisplayClick, ...other } = props
    const { user, logout } = useAuth()
    // Docs are open to site admins and partner admins; show Help to both and send
    // each to the right landing page.
    const isSiteAdmin = !!user && hasRole(user, ['Site Admin Role'])
    const isPartnerStaff = Boolean(user?.isPartnerStaff)
    const canSeeDocs = isSiteAdmin || isPartnerStaff
    const docsHelpPath = isSiteAdmin ? '/docs/power/welcome' : '/docs/partner/guide'
    const accountItem = settingsItems[0]

    const handleLogout = useCallback(async () => {
        try {
            onClose?.()
            await logout()
        } catch (err) {
            console.error(err)
            toast.error('Unable to logout.')
        }
    }, [logout, onClose])

    return (
        <Popover
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'center',
                vertical: 'bottom'
            }}
            disableScrollLock
            onClose={onClose}
            open={!!open}
            // PaperProps={{ sx: { width: 200 } }}
            {...other}
        >
            <Box sx={{ p: 2 }}>
                <Typography variant="body1">{user.username}</Typography>
                <Typography color="text.secondary" variant="body2">
                    {user.email}
                </Typography>
            </Box>
            <Divider />
            <Box sx={{ p: 1 }}>
                {accountItem && (
                    <ListItemButton
                        component={RouterLink}
                        to={accountItem.path}
                        onClick={onClose}
                        sx={{
                            borderRadius: 1,
                            px: 1,
                            py: 0.5
                        }}
                    >
                        <ListItemIcon>{accountItem.icon}</ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">
                                    {accountItem.label}
                                </Typography>
                            }
                        />
                    </ListItemButton>
                )}
                <ListItemButton
                    onClick={onDisplayClick}
                    sx={{
                        borderRadius: 1,
                        px: 1,
                        py: 0.5
                    }}
                >
                    <ListItemIcon>
                        <SvgIcon fontSize="small">
                            <TuneIcon />
                        </SvgIcon>
                    </ListItemIcon>
                    <ListItemText
                        primary={
                            <Typography variant="body1">Display</Typography>
                        }
                    />
                </ListItemButton>
                {canSeeDocs && (
                    <ListItemButton
                        component={RouterLink}
                        to={docsHelpPath}
                        onClick={onClose}
                        sx={{
                            borderRadius: 1,
                            px: 1,
                            py: 0.5
                        }}
                    >
                        <ListItemIcon>
                            <SvgIcon fontSize="small">
                                <HelpOutlineIcon />
                            </SvgIcon>
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="body1">Help</Typography>
                            }
                        />
                    </ListItemButton>
                )}
            </Box>
            <Divider sx={{ my: '0 !important' }} />
            <Box
                sx={{
                    display: 'flex',
                    p: 1,
                    justifyContent: 'center'
                }}
            >
                <Button
                    color="inherit"
                    onClick={handleLogout}
                    size="small"
                    fullWidth
                >
                    Logout
                </Button>
            </Box>
        </Popover>
    )
}

AccountPopover.propTypes = {
    anchorEl: PropTypes.any,
    onClose: PropTypes.func,
    onDisplayClick: PropTypes.func,
    open: PropTypes.bool
}
